import { __extends } from "tslib";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { copyDeviations, moveDeviations, removeDeviations, makeDeviationCurrentGallectionCover, deselectAll, } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
import CameraIcon from '@wix/da-ds/pkg/Icons/24x24/AddCoverImage';
import MoveToFolderIcon from '@wix/da-ds/pkg/Icons/24x24/MoveToFolder';
import CopyIcon from '@wix/da-ds/pkg/Icons/Copy';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GallectionListMenu from '../GallectionListMenu';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import { areGallectionContentsManageable, getFolderIdsDisabledForDeviationCopy, canMakeDeviationPremium, getPremiumFolderIds, } from '../../helpers';
import withGallections from '../../_hocs/withGallections';
import { hasGallectionsToCopyOrMoveTo as hasGallectionsToCopyOrMoveToSelector } from '../../selectors';
import itemControlButtonStyles from '../ItemControlButtons/ItemControlButtons.scss';
var enhance = compose(withCurrentGallection, withGallections, connectMediaStore(function (state, ownProps) { return ({
    hasGallectionsToCopyOrMoveTo: hasGallectionsToCopyOrMoveToSelector(state, ownProps.currentFolderId),
}); }, {
    copyDeviations: copyDeviations,
    moveDeviations: moveDeviations,
    removeDeviations: removeDeviations,
    makeDeviationCurrentGallectionCover: makeDeviationCurrentGallectionCover,
    deselectAll: deselectAll,
}), withTranslation());
var GallectionDeviationControlButtons = /** @class */ (function (_super) {
    __extends(GallectionDeviationControlButtons, _super);
    function GallectionDeviationControlButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeConfirmationPopup = function () {
            _this.setState({ confirmationPopupType: null });
        };
        _this.openRemoveConfirmationPopup = function () {
            _this.setState({ confirmationPopupType: 'remove' });
        };
        _this.remove = function () {
            var props = _this.props;
            props.removeDeviations([props.deviation]);
        };
        _this.moveToAnotherFolder = function (folderId) {
            var props = _this.props;
            props.moveDeviations({
                targetFolderId: folderId,
                deviations: [props.deviation],
            });
        };
        _this.copyToAnotherFolder = function (folderId) {
            var props = _this.props;
            props.copyDeviations({
                targetFolderId: folderId,
                deviations: [props.deviation],
            });
        };
        _this.makeDeviationCurrentGallectionCover = function () {
            var props = _this.props;
            props.makeDeviationCurrentGallectionCover(props.deviation);
        };
        return _this;
    }
    GallectionDeviationControlButtons.prototype.render = function () {
        var _a = this.props, deviation = _a.deviation, gallections = _a.gallections, currentFolderId = _a.currentFolderId, className = _a.className, currentGallection = _a.currentGallection, hasGallectionsToCopyOrMoveTo = _a.hasGallectionsToCopyOrMoveTo, t = _a.t;
        var areDeviationsManageable = !!currentGallection && areGallectionContentsManageable(currentGallection);
        var isPremiumDeviation = !!(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData);
        var canCopyFromCurrentGallection = !(currentGallection === null || currentGallection === void 0 ? void 0 : currentGallection.premiumFolderData) && !isPremiumDeviation;
        var itemLabelKeys = {
            gallery: {
                makeCover: 'mediapopup.itemMenu.gallery.makeCover',
                moveTo: 'mediapopup.itemMenu.gallery.moveTo',
                copyTo: 'mediapopup.itemMenu.gallery.copyTo',
                deleteFrom: 'mediapopup.itemMenu.gallery.deleteFrom',
            },
            collection: {
                makeCover: 'mediapopup.itemMenu.collection.makeCover',
                moveTo: 'mediapopup.itemMenu.collection.moveTo',
                copyTo: 'mediapopup.itemMenu.collection.copyTo',
                deleteFrom: 'mediapopup.itemMenu.collection.deleteFrom',
            },
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(ItemControlButtons, { className: className, moreMenuClassName: itemControlButtonStyles['item-control-menu'], menuItems: [
                    {
                        // safe zone
                        items: [
                            {
                                label: t(itemLabelKeys[currentGallection.type].makeCover),
                                icon: React.createElement(CameraIcon, { size: IconSize.SMALL }),
                                onClick: this.makeDeviationCurrentGallectionCover,
                                disabled: !areDeviationsManageable,
                            },
                            {
                                label: t(itemLabelKeys[currentGallection.type].moveTo),
                                submenu: (React.createElement(GallectionListMenu, { onSelect: this.moveToAnotherFolder, disableFolderIds: !canMakeDeviationPremium(deviation)
                                        ? getPremiumFolderIds(gallections)
                                        : [] })),
                                disabled: !areDeviationsManageable || !hasGallectionsToCopyOrMoveTo,
                                icon: React.createElement(MoveToFolderIcon, { size: IconSize.SMALL }),
                            },
                            {
                                label: t(itemLabelKeys[currentGallection.type].copyTo),
                                submenu: (React.createElement(GallectionListMenu, { onSelect: this.copyToAnotherFolder, disableFolderIds: getFolderIdsDisabledForDeviationCopy(gallections, currentFolderId, deviation) })),
                                disabled: !canCopyFromCurrentGallection ||
                                    !hasGallectionsToCopyOrMoveTo,
                                icon: React.createElement(CopyIcon, { size: IconSize.SMALL }),
                            },
                        ],
                    },
                    {
                        // danger zone
                        items: [
                            {
                                value: 3,
                                label: t(itemLabelKeys[currentGallection.type].deleteFrom),
                                icon: React.createElement(TrashcanIcon, { size: IconSize.SMALL }),
                                danger: true,
                                disabled: !areDeviationsManageable,
                                onClick: this.remove,
                            },
                        ],
                    },
                ] })));
    };
    return GallectionDeviationControlButtons;
}(React.Component));
export { GallectionDeviationControlButtons };
export default enhance(GallectionDeviationControlButtons);
//# sourceMappingURL=GallectionDeviationControlButtons.connected.js.map